/** Точность округления расхода ТМЦ, знаков после запятой. */
const ASSET_RATE_PRECISION = 3;

export function computeApplicationRate(
  quantityReal: number,
  fieldSize: number | string | null
): number {
  const area = Number(fieldSize);
  if (!area) {
    return 0;
  }
  return Number((quantityReal / area).toFixed(ASSET_RATE_PRECISION));
}
